import React from 'react';
import styled from 'styled-components';

import i18n from '@/settings/i18n';
import { Modal } from '@/components/shared/Modal';
import { SharedButton } from '@/components/shared/Button';

import { organizationContactStore } from '@/store/organization/contact';
import { Contact } from '@/types/contact';
import { ContactFormCreateContainer } from '@/components/pages/Subscription/Container/Form/Address/ContactFormCreateContainer';
import { ContactFormUpdateContainer } from '@/components/pages/Subscription/Container/Form/Address/ContactFormUpdateContainer';
import { useAppDispatch } from '@/store';

export type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFieldValue: {
    (
      field:
        | 'billingContactId'
        | 'contactId'
        | 'serviceIds'
        | 'adminIds'
        | 'users'
        | 'startsOn'
        | 'projectClassId',
      value: any,
      shouldValidate?: boolean | undefined,
    ): void;
    (field: string, value: any): void;
  };
  mode?: 'new' | 'edit';
  targetContact?: Contact;
};

export const ContactModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  setFieldValue,
  mode = 'new',
  targetContact,
}) => {
  const dispatch = useAppDispatch();
  return (
    <Modal
      closeOnDimmerClick={false}
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      title={i18n.t(
        `ui.subscription.contact.contactModal.${mode || 'new'}.title`,
      )}
      emphasizeTitle={true}
      buttons={
        <>
          <SharedButton
            dataTest="cancel"
            onClick={() => setIsOpen(false)}
            color="gray"
            fontSize="small"
            fontWeight="bold"
            buttonType="tight"
          >
            {i18n.t(
              `ui.subscription.contact.contactModal.${mode || 'new'}.cancel`,
            )}
          </SharedButton>

          <SharedButton
            dataTest="execute"
            onClick={() => {
              (
                document.getElementById(
                  'address-form-submit-button',
                ) as HTMLButtonElement
              ).click();
            }}
            fontSize="small"
          >
            {i18n.t(
              `ui.subscription.contact.contactModal.${mode || 'new'}.submit`,
            )}
          </SharedButton>
        </>
      }
    >
      <ContentWrapper>
        <WarningInputDisappear>
          {i18n.t(`ui.subscription.contact.contactModal.warningInputDisappear`)}
        </WarningInputDisappear>
        {mode === 'new' && (
          <ContactFormCreateContainer
            onComplete={() => {
              setIsOpen(false);
              dispatch(organizationContactStore.asyncActions.fetchAll());
            }}
            setFieldValue={setFieldValue}
          />
        )}
        {mode === 'edit' && targetContact !== undefined && (
          <ContactFormUpdateContainer
            onComplete={() => {
              setIsOpen(false);
              dispatch(organizationContactStore.asyncActions.fetchAll());
            }}
            setFieldValue={setFieldValue}
            contact={targetContact}
          />
        )}
      </ContentWrapper>
    </Modal>
  );
};

const ContentWrapper = styled.div`
  font-family: sans-serif;
  line-height: 1.4;
`;

const WarningInputDisappear = styled.div`
  font-size: 1em;
  font-weight: lighter;
  color: #ff0000;
  margin-bottom: 0.5em;
`;
